import type {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  optiorx: {
    label: 'OptioRx',
    functions: {
      CreatePrescriptions: {
        middlewareHandler: 'optiorx',
        version: 2,
        label: 'Create Prescriptions in OptioRx',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      SyncPrescriptionStatus: {
        middlewareHandler: 'optiorx',
        version: 2,
        label: 'Sync OptioRx Prescription Status',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      SyncShipping: {
        middlewareHandler: 'optiorx',
        version: 2,
        label: 'Sync OptioRx Shipping / Delivery',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      HandleWebhook: {
        middlewareHandler: 'optiorx',
        version: 2,
        label: 'Handle Webhook',
        pipelines: ['webhook'],
        passPayload: true,
        params: []
      }
    }
  }
} as const;

export const OptioRxConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type OptioRxFunctionConfiguration = MiddlewareConfigClass<
  typeof config.optiorx.functions
>;
